/* global $ */
/* global URLS */
/* global gettext */

(function (scope) {
  "use strict";

  var PrintOverlayNotification = (scope.PrintOverlayNotification = function (
    controller
  ) {
    this.controller = controller;
    this.$el = $("#overlayNotifivationView");
    this.$list = $(".overlay-notification-container ul", this.$el);

    this.delay = 5000;
    this.slow_delay = 8000;

    this.last_message = null;

    this.$el.on(
      "click",
      ".overlay-notification-item-close",
      this.closeOverlayNotification.bind(this)
    );
  });

  /**
   * clear all notification
   * @public
   */
  PrintOverlayNotification.prototype.clear = function () {
    this.$list.empty();
  };

  /**
   * delete notification after clicking the close button
   * @public
   */
  PrintOverlayNotification.prototype.closeOverlayNotification = function (
    event
  ) {
    $(event.currentTarget).parent().remove();
  };

  /**
   * add a new overlay message
   * @public
   */
  PrintOverlayNotification.prototype.notify = function (type, message, slow) {
    var $li = $("li", this.$list);

    //if the list is empty we set last_message to null
    if ($li.length === 0) {
      this.last_message = null;
    }

    //if last_message is equal to the current message we don't show it. Avoid double or triple identical messages in a row
    if (this.last_message == message) {
      return;
    }

    //set last_message with the current message
    this.last_message = message;

    //create the li with all needed
    var $container = $("<li>")
      .addClass("overlay-notification-item")
      .addClass("animate-item");
    var $close = $("<div>").html(
      '<svg version="1.1" x="0px" y="0px" width="612px" height="612px" viewBox="0 0 612 612"><g><polygon points="612,36.004 576.521,0.603 306,270.608 35.478,0.603 0,36.004 270.522,306.011 0,575.997 35.478,611.397, 306,341.411 576.521,611.397 612,575.997 341.459,306.011"/></g></svg>'
    );
    $close.addClass("overlay-notification-item-close");
    var $content = $("<div>")
      .html(message)
      .addClass("overlay-notification-item-content");
    $container.html($content);
    $close.appendTo($container);

    //if the type is different of undefined or null
    if (type !== undefined || type !== null) {
      //add a class based on the type
      //Example : .overlay-notification-item--orientation
      //				.overlay-notification-item--solidity-check
      $container.addClass("overlay-notification-item--" + type);
    }

    //set a timer to hide it after a delay
    setTimeout(
      function () {
        $container.fadeOut(500, function () {
          $container.remove();
        });
      }.bind(this),
      slow ? this.slow_delay : this.delay
    );

    //add it to the list
    $container.prependTo(this.$list);

    if ($li.length >= 3) {
      //if there is more than 3 li we fadeout the last one but only if they're not already fading out
      var total_li = $li.length;

      for (var i = total_li - 1; i >= 2; i--) {
        var current_li = $($li[i]);
        if (current_li.data("is_fadingOut") == true) {
          continue;
        } else {
          current_li.data("is_fadingOut", true);
        }
        current_li.fadeOut(500, function () {
          current_li.remove();
        });
      }
    }
  };

  //all the type available
  PrintOverlayNotification.TYPE = {};
  PrintOverlayNotification.TYPE.ERROR = "error";
  PrintOverlayNotification.TYPE.SAVED = "saved";
  PrintOverlayNotification.TYPE.INFO = "info";
  PrintOverlayNotification.TYPE.RESET = "reset";
  PrintOverlayNotification.TYPE.UPDATE = "update";

  PrintOverlayNotification.TYPE.DASHBOARD = "dashboard";
  PrintOverlayNotification.TYPE.ORIENTATION = "orientation";
  PrintOverlayNotification.TYPE.BATCH_CONTROL = "batch";
  PrintOverlayNotification.TYPE.HOLLOWING = "hollowing";
  PrintOverlayNotification.TYPE.THICKENING = "thickening";
  PrintOverlayNotification.TYPE.ANNOTATIONS = "annotations";
  PrintOverlayNotification.TYPE.SLICER = "annotations";

  PrintOverlayNotification.TYPE.DEFAULT = "default";
  PrintOverlayNotification.TYPE.SOLIDITY_CHECK = "solidity-check";
  PrintOverlayNotification.TYPE.CUTEWAY = "cutaway";
  PrintOverlayNotification.TYPE.WIREFRAME = "wireframe";

  PrintOverlayNotification.TYPE.CONFIGURATION = "configuration";
  PrintOverlayNotification.TYPE.REVIEW = "review";
})((window.sculpteo = window.sculpteo || {}));
